// import merge from "lodash/merge";
import { wpClient } from "../wp-client";

export default {
  async create(quantity = 0) {
    const body = { quantity };
    try {
      const response = await wpClient.post("sitio/v1/credits-order", body);
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error.response.data.message);
    }
  },
  async capture(paypalOrderID) {
    try {
      const response = await wpClient.post(
        "sitio/v1/credits-order/capture/" + paypalOrderID,
      );
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error.response.data.message);
    }
  },
};
